import { ref, get } from "firebase/database";
import { database } from "../../../Utils/firebase";
import * as actionType from "../../../context/actions";
import GetAssignerUserBusinessData from "./Business/GetAssignerUserBusinessDataInFirebase";

const GetAssignerUserDataInfirebase = async (state, dispatch, authUserId) => {

    const MEMBER_UID = authUserId;

    console.log("MEMBER_UID", MEMBER_UID);

    if (!MEMBER_UID) {
        dispatch({ type: actionType.ASSIGNERUSER, payload: [] });
        return [];
    }

    try {

        const sharedRef = ref(
            database,
            `invoiceGenerator/sharedWithUsers/${MEMBER_UID}`
        );

        let snapshot = null;
        let retryCount = 0;
        
        while (retryCount < 3) {
            try {
                snapshot = await get(sharedRef);
                break;
            } catch (err) {
                console.warn(`Retry ${retryCount + 1} for sharedWithUsers due to auth latency...`);
                retryCount++;
                if (retryCount >= 3) throw err;
                await new Promise(r => setTimeout(r, 1500));
            }
        }

        if (!snapshot.exists()) {
            dispatch({ type: actionType.ASSIGNERUSER, payload: [] });
            return [];
        }

        const ownerIds = snapshot.val().ownerIds || [];
        console.log("ownerIds", ownerIds);

        const ownersData = [];

        const promises = ownerIds.map(async (ownerUid) => {

            const ownerRef = ref(
                database,
                `invoiceGenerator/users/${ownerUid}`
            );

            const ownerSnap = await get(ownerRef);
            if (ownerSnap.exists()) {
                ownersData.push({
                    ownerUid,
                    ...ownerSnap.val()
                });
            }

        });

        await Promise.all(promises);

        dispatch({
            type: actionType.ASSIGNERUSER,
            payload: ownersData
        });

        // ✅ Now fetch shared businesses
        // await GetAssignerUserBusinessData(state, dispatch, MEMBER_UID, ownerIds);

        return ownersData;

    } catch (error) {

        console.error("Shared owner fetch error:", error);
        return [];

    }
};

export default GetAssignerUserDataInfirebase;